import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useLocCountries = () => useQuery({ queryKey: ['countries'], queryFn: async () => {
    const callback = await API.get('/common/loc/countries')
    return callback?.data
}})

export default useLocCountries